/* eslint-disable @typescript-eslint/no-redeclare */

/* eslint-disable jsx-a11y/anchor-is-valid */
import { ZoomInOutlined, CheckCircleFilled } from '@ant-design/icons';
import { Row, Col, Input, Card, Button, Modal, Select, message, Spin } from 'antd';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import { Formik, FormikHelpers } from 'formik';
import { Form, SubmitButton } from 'formik-antd';
import moment from 'moment';
import {
  getBillingDetailsCPAP,
  getBillingDetailsCPAPSpecial,
  getBillingDetailsPSG,
  getBillingDetailsSimple,
  getBillingDetailNearest,
  getPaymentDueDateFromInvoiceMonth,
  changeStatusBillInvoice,
  updateBillInvoice,
  updateLastBillInvoice,
  updateHospitalByCSV,
  getResultImport,
  getListOtherDetail,
} from 'pages/BillingProcess/thunk';
import { updateMedical } from 'pages/MedicalInstitutionRegister/MedicalInstitutionEdit/thunk';
import {
  getCountFacilityCode,
  getDataStoreFieldMedicals,
  updateCountFacilityCode,
} from 'pages/MedicalInstitutionRegister/thunk';
import { FC, useState, useEffect, useMemo } from 'react';
import Props from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from 'store';
import { t_medical_institution } from 'types';
import { PaymentMethodSearch } from 'utils';
import ModalCalendar from '../../../components/Calendar';
import { Wrapper } from './styles';

const { TextArea } = Input;
const { Option } = Select;

type Props = {
  nextStep: () => void;
  stepToPrevious: () => void;
};
type LocationState = {
  medicalDetail: t_medical_institution;
};

const BillingFiveStep: FC<Props> = ({ nextStep, stepToPrevious }) => {
  const dispatch = useDispatch();
  const formatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
    maximumFractionDigits: 2,
  });
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [modalConfirmVisible, setModalConfirmVisible] = useState<boolean>(false);
  const [modalFinishVisible, setModalFinishVisible] = useState<boolean>(false);
  const [modalCalendarVisible, setModalCalendarVisible] = useState<boolean>(false);
  const [invoiceRemark, setInvoiceRemark] = useState<string>('');
  const { currentApplicationId } = useSelector((state: RootState) => state.workSpaces);
  const { dataStoreMedicalFields } = useSelector((state: RootState) => state.medicalRegister);
  const location = useLocation<LocationState>();
  const [option, setOption] = useState<string>(location.state.medicalDetail.payment_method || '');
  const [loadUpdate, setLoadUpdate] = useState(false);
  const [newFacility, setNewFacility] = useState<{ facility_code?: string; payment_method?: string }>({});

  const {
    itemInvoice,
    totalItemCPAPSpectial,
    totalItemCPAP,
    totalItemPSG,
    totalItemSimple,
    billNearest,
    paymentDueDate,
    hospitalCPAP,
    hospitalCPAPSpecial,
    dataPayment,
    otherDetail,
  } = useSelector(billingSelectors);
  const { statusBill } = useSelector(workSpaceSelectors);

  const last_billed = Number(billNearest && billNearest.billing_amount);
  const last_deposit = Number(billNearest && billNearest.payment_amount) + Number(billNearest?.payment_fees ?? 0);
  const carryover_amount = Number(billNearest && billNearest.carried_forward);

  const totalOther = otherDetail
    ? otherDetail.reduce((acc, cur) => {
        return acc + Number(cur.other_detail_count ?? 0) * Number(cur.other_detail_unit_price ?? 0);
      }, 0)
    : 0;

  const subtotal = Number(
    Number(totalItemCPAP * Number(location.state.medicalDetail.cpap_unit_price ?? 0)) +
      Number(totalItemCPAPSpectial * Number(location.state.medicalDetail.cpap_unit_sp_price ?? 0)) +
      Number(totalItemPSG * Number(location.state.medicalDetail.psg_unit_price ?? 0)) +
      Number(totalItemSimple * Number(location.state.medicalDetail.simplicity_unit_price ?? 0)) +
      totalOther,
  );

  const tax = Math.round(
    Number(
      ((Number(totalItemCPAP * Number(location.state.medicalDetail.cpap_unit_price ?? 0)) +
        Number(totalItemCPAPSpectial * Number(location.state.medicalDetail.cpap_unit_sp_price ?? 0)) +
        Number(totalItemPSG * Number(location.state.medicalDetail.psg_unit_price ?? 0)) +
        Number(totalItemSimple * Number(location.state.medicalDetail.simplicity_unit_price ?? 0)) +
        totalOther) *
        10) /
        100,
    ),
  );

  const disableSubmit =
    billNearest &&
    (billNearest.Status === 'Billing in progress' ||
      billNearest.Status === '請求書作成中' ||
      billNearest.Status === 'Invoicing completed' ||
      billNearest.Status === '請求書登録済' ||
      billNearest.Status === 'invoice issued' ||
      billNearest.Status === '請求書発行済');

  useEffect(() => {
    const month = Number(itemInvoice?.invoice_month?.slice(4) ?? 0);
    let monthRequest = 1;
    let year = new Date().getFullYear();
    if (month !== 0) {
      monthRequest = 1;
      year = Number(itemInvoice?.invoice_month?.slice(0, 4)) ?? new Date().getFullYear();
      if (month + 1 > 12) {
        year += 1;
        monthRequest = 1;
      } else {
        monthRequest = month + 1;
      }
    }
    setLoadUpdate(true);
    (async () => {
      await Promise.all([
        currentApplicationId &&
          dispatch(
            getDataStoreFieldMedicals({
              appId: currentApplicationId,
              dataStoreId: 't_medical_institution',
            }),
          ),
        dispatch(
          getBillingDetailsCPAPSpecial({
            page: 1,
            per_page: 0,
            facility_id: location.state.medicalDetail.i_id || '',
            sp_price: '特別料金対象',
            invoice_month: itemInvoice?.invoice_month || '',
          }),
        ),
        dispatch(
          getBillingDetailsCPAP({
            page: 1,
            per_page: 0,
            facility_id: location.state.medicalDetail.i_id || '',
            sp_price: '特別料金対象',
            invoice_month: itemInvoice?.invoice_month || '',
          }),
        ),
        dispatch(
          getBillingDetailsPSG({
            page: 1,
            per_page: 0,
            facility_id: location.state.medicalDetail.i_id || '',
            invoice_month: itemInvoice?.invoice_month || '',
          }),
        ),
        dispatch(
          getBillingDetailsSimple({
            page: 1,
            per_page: 0,
            facility_id: location.state.medicalDetail.i_id || '',
            invoice_month: itemInvoice?.invoice_month || '',
          }),
        ),
        dispatch(
          getBillingDetailNearest({
            page: 1,
            per_page: 0,
            facility_id: location.state.medicalDetail.i_id || '',
            invoice_month: itemInvoice?.invoice_month ?? '',
          }),
        ),

        dispatch(
          getPaymentDueDateFromInvoiceMonth({
            page: 1,
            per_page: 1,
            invoice_month: `${year}${monthRequest < 10 ? '0' + monthRequest : monthRequest}`,
          }),
        ),
        dispatch(
          getListOtherDetail({
            facility_id: location.state.medicalDetail.i_id ?? '',
            invoice_id: itemInvoice?.invoice_id ?? '',
          }),
        ),
      ]);
      setLoadUpdate(false);
    })();
  }, [dispatch, currentApplicationId, itemInvoice, location.state.medicalDetail.i_id]);

  const paymentMethod = useMemo(() => {
    return (
      dataStoreMedicalFields?.find(([_key, value]: [string, any]) => value.display_id === 'payment_method')[1]
        .options || []
    );
  }, [dataStoreMedicalFields]);

  useEffect(() => {
    dispatch(
      getListOtherDetail({
        facility_id: location.state.medicalDetail.i_id ?? '',
        invoice_id: itemInvoice?.invoice_id ?? '',
      }),
    );
  }, [dispatch, location, itemInvoice]);

  const updatePaymentMethod = async () => {
    let items: any = null;
    const payment = paymentMethod.find((g: any) => g.value === option);
    let newFcode = location.state.medicalDetail.facility_code;
    if (option !== location.state.medicalDetail.payment_method) {
      items = await dispatch(getCountFacilityCode(PaymentMethodSearch(option)));
      const codeNumber = (+items.payload[0].count + 1).toString();
      newFcode = items.payload[0].prefix + '-';
      newFcode += codeNumber.length === 1 ? '00' + codeNumber : codeNumber.length === 2 ? '0' + codeNumber : codeNumber;
    }
    const dataUpdate: t_medical_institution = {
      i_id: location.state.medicalDetail.i_id,
      d_id: location.state.medicalDetail.d_id,
      payment_method: payment && payment.option_id,
      facility_code: newFcode,
    };
    const result = await dispatch(updateMedical(dataUpdate));
    if ('payload' in result) {
      setNewFacility({ facility_code: newFcode, payment_method: option });
      items && dispatch(updateCountFacilityCode({ ...items.payload[0], count: parseInt(items.payload[0].count) + 1 }));
    }
  };

  const handleConfirmChange = () => {
    setModalVisible(false);
    setModalConfirmVisible(true);
  };
  const handleFinishChange = () => {
    updatePaymentMethod();
    setModalConfirmVisible(false);
    setModalFinishVisible(true);
  };
  const closeModal = () => {
    setModalFinishVisible(false);
  };

  const handleSubmit = async (values: any, form: FormikHelpers<any>) => {
    setLoadUpdate(true);
    let payment_method = newFacility.payment_method ?? location.state.medicalDetail.payment_method;
    let payment_due_date;
    switch (payment_method) {
      case '振替':
        if (dataPayment?.payment_due_date || paymentDueDate?.payment_due_date) {
          payment_due_date = moment(
            `${dataPayment?.payment_due_date || paymentDueDate?.payment_due_date}`,
          ).toISOString();
        } else {
          payment_due_date = moment().set('date', 27).toISOString();
        }
        break;
      case '振込':
        payment_due_date = moment().endOf('month').toISOString();
        break;
      default:
        payment_due_date = null;
        break;
    }
    const initialValues = {
      facility_code: location.state.medicalDetail.facility_code,
      payment_method,
      payment_due_date,
      cpap_unit_price: Number(location.state.medicalDetail.cpap_unit_price),
      cpap_count: totalItemCPAP,
      cpap_unit_sp_price: Number(location.state.medicalDetail.cpap_unit_sp_price),
      cpap_sp_count: totalItemCPAPSpectial,
      psg_unit_price: Number(location.state.medicalDetail.psg_unit_price),
      psg_count: totalItemPSG,
      simplicity_unit_price: Number(location.state.medicalDetail.simplicity_unit_price),
      simplicity_count: totalItemSimple,
      subtotal: subtotal,
      tax: tax,
      total: rouNumber(subtotal + tax),
      last_billed_amount: last_billed,
      last_deposit: last_deposit,
      carryover_amount: carryover_amount,
      billing_amount: rouNumber(subtotal + tax + carryover_amount),
      invoice_remark: invoiceRemark,
      billable_month: Number(location.state.medicalDetail.billable_month),
    };
    if (billNearest) {
      await dispatch(updateLastBillInvoice({ i_id: billNearest.i_id || '' }));
    }
    console.log('itemInvoice?.Status: ' + itemInvoice?.Status);
    if (
      itemInvoice?.Status === '請求書発行済' ||
      itemInvoice?.Status === 'invoice issued' ||
      itemInvoice?.Status === '請求書登録済' ||
      itemInvoice?.Status === 'Invoicing completed'
    ) {
      await dispatch(updateBillInvoice({ values: initialValues, i_id: itemInvoice?.i_id || '' }));
    } else {
      await dispatch(changeStatusBillInvoice({ values: initialValues, i_id: itemInvoice?.i_id || '' }));
    }

    if (totalItemCPAP > 0 || totalItemCPAPSpectial > 0) {
      const result: any = await dispatch(
        updateHospitalByCSV({
          invoice_id: itemInvoice?.invoice_id,
          dataHospital: [...hospitalCPAP, ...hospitalCPAPSpecial],
        }),
      );

      if (result.payload.result) {
        setLoadUpdate(false);
        form.setSubmitting(false);
        nextStep();
      } else if (result.payload.error) {
        setLoadUpdate(false);
        message.error('データインポート中にエラーが発生しました。処理を中断し、システム管理会社にご連絡ください。', 5);
      } else {
        const getStatusImport = async (stream_id: string) => {
          const resultImport: any = await dispatch(
            getResultImport({
              stream_id: stream_id,
            }),
          );
          const obj = resultImport ? resultImport.payload : null;
          if (obj) {
            const status = obj[Object.keys(obj)[0]].status;
            if (status.id === 0 || status.id === 1) {
              setTimeout(() => getStatusImport(stream_id), 5000);
            } else if (status.id === 2) {
              setLoadUpdate(false);
              form.setSubmitting(false);
              nextStep();
            } else {
              setLoadUpdate(false);
              message.error(
                'データインポート中にエラーが発生しました。処理を中断し、システム管理会社にご連絡ください。',
                5,
              );
            }
          }
        };
        getStatusImport(result.payload.stream_id);
      }
    } else {
      setLoadUpdate(false);
      nextStep();
    }
  };

  const renderPaymentDueDate = useMemo(() => {
    switch (newFacility.payment_method ?? location.state.medicalDetail.payment_method) {
      case '振替':
        if (paymentDueDate?.payment_due_date || dataPayment?.payment_due_date) {
          const momentDate = moment(paymentDueDate?.payment_due_date || dataPayment?.payment_due_date);
          return momentDate.startOf('day').format('YYYY年MM月DD日');
        }
        return moment().set('date', 27).format('YYYY年MM月DD日');
      case '振込':
        return moment().endOf('month').format('YYYY年MM月DD日');
      case 'カード決済':
        return 'カード会社に準ずる';
      default:
        return '';
    }
  }, [
    newFacility.payment_method,
    location.state.medicalDetail.payment_method,
    dataPayment?.payment_due_date,
    paymentDueDate?.payment_due_date,
  ]);

  return (
    <Spin spinning={loadUpdate} size="large">
      <Wrapper>
        <div className="section">
          <div className="extraLargeFont m-l5px">6. 請求内容登録</div>
          <Formik
            onSubmit={handleSubmit}
            initialValues={{}}
            render={() => (
              <Form>
                <div className="info">
                  {itemInvoice?.editing_status_by_clinic === '編集中' ? (
                    <span style={{ marginRight: '46%', color: 'red' }}>
                      医療機関が編集中のため、請求書を作成できません。
                    </span>
                  ) : (
                    <span style={{ marginRight: '46%', color: 'red' }}></span>
                  )}
                  <p className="transaction-number smallFont">お取引番号</p>
                  <p className="number smallFont">
                    {newFacility.facility_code ?? location.state.medicalDetail.facility_code}
                  </p>
                </div>
                <div className="pay">
                  <div className="wrap-bill pd-7">
                    <Row>
                      <Col className="middleBoldFont" span={19}>
                        支払い条件
                      </Col>
                      <Col className="middleBoldFont" style={{ textAlign: 'right' }} span={5}>
                        {newFacility.payment_method ?? location.state.medicalDetail.payment_method}
                      </Col>
                    </Row>
                  </div>
                  <div className="wrap-bill pd-7">
                    <Row className="bd-style">
                      {statusBill?.value === itemInvoice?.invoice_month ? null : (
                        <Col className="smallBoldFont pd-7" span={24} style={{ textAlign: 'right', color: '#ff8a00' }}>
                          <a
                            className="smallBoldFont"
                            onClick={() => setModalVisible(true)}
                            style={{ paddingRight: 0, color: '#ff8a00' }}
                          >
                            <ZoomInOutlined style={{ marginRight: '5px' }} />
                            支払い条件を変更する
                          </a>
                          <Modal
                            title="支払い条件の変更"
                            centered
                            closable={false}
                            visible={modalVisible}
                            onOk={() => handleConfirmChange()}
                            onCancel={() => setModalVisible(false)}
                            okText="変更する"
                            cancelText="閉じる"
                          >
                            <p
                              style={{ marginTop: '15px', marginBottom: '36px', textAlign: 'center' }}
                              className="middleBoldFont"
                            >
                              {location.state.medicalDetail.facility_name}現在の支払い条件：
                              {location.state.medicalDetail.payment_method}
                            </p>
                            <Select
                              onChange={(e) => setOption(e)}
                              value={option}
                              size={'middle'}
                              defaultValue="振込"
                              style={{ width: 265, height: 35, marginLeft: '100px' }}
                            >
                              {paymentMethod.map((g: any, i: number) => (
                                <Option key={i} value={g.value}>
                                  {g.value}
                                </Option>
                              ))}
                            </Select>
                          </Modal>

                          <Modal
                            title="支払い条件の変更"
                            centered
                            closable={false}
                            visible={modalConfirmVisible}
                            onOk={() => handleFinishChange()}
                            onCancel={() => setModalConfirmVisible(false)}
                            okText="変更する"
                            cancelText="閉じる"
                          >
                            <p
                              style={{ marginTop: '15px', marginBottom: '36px', textAlign: 'center' }}
                              className="middleBoldFont"
                            >
                              {location.state.medicalDetail.facility_name}クの現在の支払い条件を
                              {location.state.medicalDetail.payment_method}から{option}に変更します。
                              支払い方法を変更すると、医療機関の取引先番号が変更されます。 よろしいですか？
                            </p>
                          </Modal>
                          <Modal
                            title="支払い条件の変更"
                            centered
                            closable={false}
                            visible={modalFinishVisible}
                            onCancel={() => closeModal()}
                            cancelText="閉じる"
                            okButtonProps={{ style: { display: 'none' } }}
                          >
                            <CheckCircleFilled
                              style={{
                                color: '#c1e18d',
                                width: '70px',
                                height: '70px',
                                margin: '0px 0px 18px 200px',
                                fontSize: '55px',
                              }}
                            />
                            <p style={{ textAlign: 'center', color: '#80a445' }} className="middleBoldFont">
                              変更しました
                            </p>
                          </Modal>
                        </Col>
                      )}
                    </Row>
                  </div>
                  <div className="wrap-bill pd-7">
                    <Row>
                      <Col className="middleBoldFont" span={19}>
                        支払い期日
                      </Col>
                      <Col className="middleBoldFont t-al" span={5}>
                        {renderPaymentDueDate}
                      </Col>
                    </Row>
                  </div>
                  <div className="wrap-bill pd-15">
                    <Row className="bd-style">
                      {(newFacility.payment_method ?? location.state.medicalDetail.payment_method) === '振替' &&
                      statusBill?.value !== itemInvoice?.invoice_month ? (
                        <Col className="smallBoldFont pd-7" span={24} style={{ textAlign: 'right', color: '#ff8a00' }}>
                          <a
                            className="smallBoldFont"
                            onClick={() => setModalCalendarVisible(true)}
                            style={{ paddingRight: 0, color: '#ff8a00' }}
                          >
                            <ZoomInOutlined style={{ marginRight: '5px' }} />
                            支払い期日を変更する
                          </a>
                          <ModalCalendar visible={modalCalendarVisible} eventActive={setModalCalendarVisible} />
                        </Col>
                      ) : null}
                    </Row>
                  </div>
                  <div className="wrap-bill pd-15">
                    <Row className="bd-style pd-15">
                      <Col className="smallBoldFont" span={8}>
                        CPAP療法レンタル
                      </Col>
                      <Col span={2}>数量</Col>
                      <Col span={3}>{totalItemCPAP}</Col>
                      <Col span={3}>単価</Col>
                      <Col span={4}>{location.state.medicalDetail.cpap_unit_price}円</Col>
                      <Col className="standardBoldFont t-al" span={4}>
                        {formatter
                          .format(totalItemCPAP * Number(location.state.medicalDetail.cpap_unit_price || 0))
                          .substring(1)}
                        円
                      </Col>
                    </Row>
                  </div>
                  <div className="wrap-bill pd-15">
                    <Row className="bd-style pd-15">
                      <Col className="smallBoldFont" span={8}>
                        CPAP療法レンタル(特別料金)
                      </Col>
                      <Col span={2}>数量</Col>
                      <Col span={3}>{totalItemCPAPSpectial}</Col>
                      <Col span={3}>単価</Col>
                      <Col span={4}>{location.state.medicalDetail.cpap_unit_sp_price}円</Col>
                      <Col className="standardBoldFont t-al" span={4}>
                        {formatter
                          .format(totalItemCPAPSpectial * Number(location.state.medicalDetail.cpap_unit_sp_price || 0))
                          .substring(1)}
                        円
                      </Col>
                    </Row>
                  </div>
                  <div className="wrap-bill pd-15">
                    <Row className="bd-style pd-15">
                      <Col className="smallBoldFont" span={8}>
                        出張PSG検査料
                      </Col>
                      <Col span={2}>数量</Col>
                      <Col span={3}>{totalItemPSG}</Col>
                      <Col span={3}>単価</Col>
                      <Col span={4}>{location.state.medicalDetail.psg_unit_price}円</Col>
                      <Col className="standardBoldFont t-al" span={4}>
                        {formatter
                          .format(totalItemPSG * Number(location.state.medicalDetail.psg_unit_price || 0))
                          .substring(1)}
                        円
                      </Col>
                    </Row>
                  </div>
                  <div className="wrap-bill pd-15">
                    <Row className="bd-style pd-15">
                      <Col className="smallBoldFont" span={8}>
                        簡易PSG検査料
                      </Col>
                      <Col span={2}>数量</Col>
                      <Col span={3}>{totalItemSimple}</Col>
                      <Col span={3}>単価</Col>
                      <Col span={4}>{location.state.medicalDetail.simplicity_unit_price}円</Col>
                      <Col className="standardBoldFont t-al" span={4}>
                        {formatter
                          .format(totalItemSimple * Number(location.state.medicalDetail.simplicity_unit_price || 0))
                          .substring(1)}
                        円
                      </Col>
                    </Row>
                  </div>
                  {otherDetail &&
                    otherDetail.map((other, index) => (
                      <div key={index} className={index < otherDetail.length - 1 ? 'wrap-bill pd-15' : 'wrap-bill'}>
                        <Row className="bd-style pd-15">
                          <Col className="smallBoldFont" span={8}>
                            {other.detail_name ?? ''}
                          </Col>
                          <Col span={2}>数量</Col>
                          <Col span={3}>{other.other_detail_count ?? 0}</Col>
                          <Col span={3}>単価</Col>
                          <Col span={4}>{other.other_detail_unit_price ?? 0}円</Col>
                          <Col className="standardBoldFont t-al" span={4}>
                            {(
                              Number(other.other_detail_count ?? 0) * Number(other.other_detail_unit_price ?? 0)
                            )?.toLocaleString()}
                            円
                          </Col>
                        </Row>
                      </div>
                    ))}
                  <div className="wrap-bill pd-15">
                    <Row className="detail-bill pd-15 bd-solid">
                      <Col className="standardFont" span={10}>
                        小計
                      </Col>
                      <Col className="t-al standardBoldFont" span={14}>
                        {subtotal?.toLocaleString()}円
                      </Col>
                    </Row>
                    <Row className="detail-bill pd-15 bd-solid">
                      <Col className="standardFont" span={10}>
                        消費税(10%)
                      </Col>
                      <Col className="t-al standardBoldFont" span={14}>
                        {Number(tax.toString().split('.')[0]).toLocaleString()}円
                      </Col>
                    </Row>
                    <Row className="detail-bill pd-15 bd-solid-2">
                      <Col className="standardBoldFont" span={10}>
                        合計
                      </Col>
                      <Col className="t-al standardBoldFont" span={14}>
                        {rouNumber(subtotal + tax)?.toLocaleString()}円
                      </Col>
                    </Row>
                    <Row className="smallFont" style={{ textAlign: 'right' }}>
                      <Col span={24}>※10円未満切り捨て</Col>
                    </Row>
                  </div>
                  <Row className="wrap-bill pd-30">
                    <Col className="smallBoldFont pd-7" span={24}>
                      備考
                    </Col>
                    <Col span={24}>
                      <TextArea className="txt-area" allowClear onChange={(e) => setInvoiceRemark(e.target.value)}>
                        {invoiceRemark}
                      </TextArea>
                    </Col>
                  </Row>
                </div>
                <div className="mgrl-25 mgt-13">
                  {' '}
                  <Row className="dl">
                    <Col span={4}>
                      <Card className="w-card w-gb-gr smallBoldFont" title="前回請求額">
                        <div className="money-info">{formatter.format(Number(billNearest?.billing_amount ?? 0))}</div>
                      </Card>
                    </Col>
                    <Col span={4}>
                      <Card className="w-card w-gb-gr smallBoldFont" title="前回入金額">
                        <div className="money-info">
                          {formatter.format(
                            Number(billNearest?.payment_amount ?? 0) + Number(billNearest?.payment_fees ?? 0),
                          )}
                        </div>
                      </Card>
                    </Col>
                    <Col span={4}>
                      <Card className="w-card w-gb-gr smallBoldFont" title="繰越金額">
                        <div className="money-info">{formatter.format(Number(billNearest?.carried_forward ?? 0))}</div>
                      </Card>
                    </Col>
                    <Col span={4}>
                      <Card className="w-card w-bg-ec smallBoldFont" title="当月請求額">
                        <div className="money-info">{formatter.format(rouNumber(subtotal + tax))}</div>
                      </Card>
                    </Col>
                    <Col span={4}>
                      <Card className="w-card w-bg smallBoldFont" title="合計請求額">
                        <div className="money-info">
                          {formatter.format(rouNumber(Number(billNearest?.carried_forward ?? 0) + subtotal + tax))}
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </div>
                {statusBill?.value === itemInvoice?.invoice_month ? null : (
                  <>
                    <div className="standardBoldFont mgt-36">
                      この内容で請求書を登録します。よろしければ登録を行い、請求書PDFを出力してください。
                    </div>
                    {disableSubmit && (
                      <div className="standardBoldFont mgt-36 error">
                        前回の入金処理が終わっていないため、請求書を作成できません。
                      </div>
                    )}
                  </>
                )}
                <div className="confirm-step">
                  <Button onClick={() => stepToPrevious()} className="btn-cancel-save">
                    戻る
                  </Button>
                  {statusBill?.value === itemInvoice?.invoice_month ? null : (
                    <SubmitButton
                      disabled={itemInvoice?.editing_status_by_clinic === '編集中' ? true : disableSubmit}
                      className="btn-save"
                    >
                      請求書を登録する
                    </SubmitButton>
                  )}
                </div>
              </Form>
            )}
          />
        </div>
      </Wrapper>
    </Spin>
  );
};

const rouNumber = (num: number) => {
  return Math.floor(num / 10) * 10;
};

export default BillingFiveStep;
